/* Material */
import Typo from '@mui/material/Typography'
import InfoIcon from '@mui/icons-material/Info'

/* Config */
import config from 'src/config'

const { stockDeliveryTime } = config

const renderDeliverytime = (
  deliverytime: number, 
  qty: number, 
  stock: number, 
  stockDeliverytime?: number,
) => {
  const resolvedStockDeliverytime = stockDeliverytime ?? stockDeliveryTime

  if (stock > 0 && qty <= stock)
    return <Typo>Lieferzeit: {resolvedStockDeliverytime} Werktage*²</Typo>

  if (stock > 0 && qty > stock) {
    const oderQty = qty - stock

    return <div>
      <Typo component='div'>{stock} x Lieferzeit: {resolvedStockDeliverytime} Werktage*²</Typo>
      <Typo component='div'>{oderQty} x Bestellware · ca. {deliverytime} Werktage*²</Typo>

      <Typo
        component='div'
        color='error'
        sx={{
          alignItems: 'flex-start',
          display: 'flex',
          gap: .75,
          marginTop: .5,
          maxWidth: 380,
        }}
      >
        <InfoIcon fontSize='small' sx={{ marginTop: .15 }} />
        <span>Bestellware wird für Sie beim Hersteller bestellt.</span>
      </Typo>
    </div>
  }

  return <Typo>Bestellware · ca. {deliverytime} Werktage*²</Typo>
}

export default renderDeliverytime
